module.exports = __webpack_public_path__ + "img/icon2.9d7d489b.png";